/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconCircleArrowRightFilled = createSolidComponent(
  "circle-arrow-right-filled",
  "IconCircleArrowRightFilled",
  [
    [
      "path",
      {
        d: "M12 2l.324 .005a10 10 0 1 1 -.648 0l.324 -.005zm.613 5.21a1 1 0 0 0 -1.32 1.497l2.291 2.293h-5.584l-.117 .007a1 1 0 0 0 .117 1.993h5.584l-2.291 2.293l-.083 .094a1 1 0 0 0 1.497 1.32l4 -4l.073 -.082l.064 -.089l.062 -.113l.044 -.11l.03 -.112l.017 -.126l.003 -.075l-.007 -.118l-.029 -.148l-.035 -.105l-.054 -.113l-.071 -.111a1.008 1.008 0 0 0 -.097 -.112l-4 -4z",
        "stroke-width": "0",
        fill: "currentColor"
      }
    ]
  ]
);

export { IconCircleArrowRightFilled as default };
//# sourceMappingURL=IconCircleArrowRightFilled.js.map
